export const SourceCustomer = "customers";

export const TitleCustomer = { list: "Customer List", edit: "Edit Customer", create: "Create Customer" };
